import {Tooltip} from 'react-tooltip'
import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {KTIcon} from '../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import {ModeleProvenance} from '../../../components/Models'
import {deleteProvenance, getProvenances} from '../../../components/requests'
import {Pagination} from '../../../components/Pagination'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import Swal from 'sweetalert2'
import {useAuth} from '../../modules/auth'

const ProvenanceListPage = () => {
  const [data, setData] = useState<Array<ModeleProvenance>>([])
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [spinner, setSpinner] = useState(true)
  const navigate = useNavigate()
  const {currentUser} = useAuth()

  const getAllDelaisTraitement = () => {
    getProvenances(currentPage)
      .then((response) => {
        if (response?.data !== undefined && response?.status === 200) {
          setData(response?.data?.data)
          setCurrentPage(response?.data?.page)
          setNombreDePages(response?.data?.pages)
          setTotalPages(response?.data?.total)
        }
      })
      .catch((error) => {
        console.log('error')
      })
      .finally(() => {
        setSpinner(false)
      })
  }

  const removeProvenance = (provenanceId: number | undefined) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToast = toast.loading('Suppression en cours...')
        deleteProvenance(provenanceId)
          .then((response) => {
            if (response?.status === 200) {
              const filteredData = data.filter((provenance) => provenance.id !== provenanceId)
              setData(filteredData)
              toast.update(idToast, {
                render: 'Provenance supprimée avec succès.',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            }
          })
          .catch((error) => {
            toast.update(idToast, {
              render: 'Erreur lors de la suppression.',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
          })
      }
    })
  }

  useEffect(() => {
    setSpinner(true)
    getAllDelaisTraitement()
  }, [currentPage])

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-lg-12 col-sm-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* debut champs recherche */}
            {shouldDisplayFonctionnalite(currentUser, 'VOIR PROVENANCE') && (
              <>
                <div className='card-header border-0 pt-5 justify-content-end'>
                  {shouldDisplayFonctionnalite(currentUser, 'AJOUTER PROVENANCE') && (
                    <div className='card-toolbar'>
                      <Link to={`/provenances/ajouter`} className='btn btn-sm btn-light-primary'>
                        <KTIcon iconName='plus' className='fs-3' />
                        Créer une provenance
                      </Link>
                    </div>
                  )}
                </div>
                {/* fin champs recherche */}
                <div className='card-body py-3'>
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th>Code</th>
                          <th>Libellé</th>
                          <th className='text-end'>Actions</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {spinner ? (
                          <tr>
                            <td colSpan={3} className='p-4 text-center h-300px'>
                              <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                            </td>
                          </tr>
                        ) : data.length === 0 ? (
                          <>
                            <tr>
                              <td colSpan={3} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          </>
                        ) : (
                          data.map((provenance) => {
                            return (
                              <tr key={provenance?.id}>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {provenance?.code}
                                  </p>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                    {provenance?.libelle}
                                  </p>
                                </td>
                                <td>
                                  <div className='d-flex justify-content-end flex-shrink-0'>
                                    {shouldDisplayFonctionnalite(
                                      currentUser,
                                      'MODIFIER PROVENANCE'
                                    ) && (
                                      <p
                                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        onClick={() =>
                                          navigate(`/provenances/${provenance?.id}/modifier`, {
                                            state: {data: provenance},
                                          })
                                        }
                                      >
                                        <i className='bi bi-pencil-square fs-2'></i>
                                      </p>
                                    )}
                                    {shouldDisplayFonctionnalite(
                                      currentUser,
                                      'SUPPRIMER PROVENANCE'
                                    ) &&
                                      !provenance?.isUsed && (
                                        <p
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() => removeProvenance(provenance?.id)}
                                        >
                                          <i className='bi bi-trash fs-2'></i>
                                        </p>
                                      )}
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                  {/* end::Table container */}

                  {/* begin::pagination*/}
                  {!spinner && (
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                  )}
                  {/* end::pagination*/}
                  {/*Affichage du tooltip*/}
                  <Tooltip id='tooltip' />
                  {/*<ToastContainer position='bottom-right' autoClose={3000} />*/}
                </div>
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {ProvenanceListPage}
